import { render, staticRenderFns } from "./QuitDialog.vue?vue&type=template&id=703b9c48&scoped=true&"
import script from "./QuitDialog.vue?vue&type=script&lang=ts&"
export * from "./QuitDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuitDialog.vue?vue&type=style&index=0&id=703b9c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b9c48",
  null
  
)

export default component.exports